export enum CellType {
  STRING = "string",
  NUMBER = "number",
  DATASET = "dataset",
  UNIT = "unit",
  SEPARATOR = "separator",
}

export enum ColorKey {
  COLOR = "color",
  BG_COLOR = "bgColor",
  MIN_TEXT_COLOR = "minTextColor",
  MAX_TEXT_COLOR = "maxTextColor",
  MIN_BG_COLOR = "minBgColor",
  MAX_BG_COLOR = "maxBgColor",
}

export enum RemoveContentType {
    COLUMN = "column",
    ROW = "row",
  }